<template>
    <div>
      <el-dialog
          :visible.sync="show_comments"
      >
        <comment-thread :compForComments="compForComments"></comment-thread>

      </el-dialog>
      <el-dialog
          title="Delete Component"
          :visible.sync="show_delete">

        <p>Are you sure you want to <strong>delete {{definition.title}}?</strong></p>
        <el-button v-on:click="really_delete()" type="danger">Yes, really delete.</el-button>
        <el-button v-on:click="cancel_delete()" type="success">Actually, do not delete.</el-button>

      </el-dialog>
      <el-dialog title="Edit Component"
                 :visible.sync="show_edit">
        <FormManager
            :initialFormValues="definition_for_editor"
            :events="events"
            @save="save"
            @cancel="cancel"
            :prettyEndPoint="'/reports/pretty_report_comps/' + definition.report_id" />
      </el-dialog>
        <div :class="col_class">
          <div></div>
            <div v-if="definition.details.chart_config && definition.details.extent_id" :style="parent_style">
                <div class="panel panel-default" :id="definition.css_id" :style="panel_style">
                    <div class="panel-heading" v-if="!overlay">
                        {{definition.title}}
                        <el-button v-if="!is_full_screen" type="text" size="mini" v-on:click="full_screen(definition.css_id)" icon="el-icon-s-platform" style="color:gray;"></el-button>
                        <span style="float:left" @click="showComments(definition)">
                          <img v-if="definition.comments && definition.comments.length" width="16px" src="/images/icons/have-noun-comment-1366158.png" />
                          <img v-else width="16px" src="/images/icons/none-noun-comment-1366158.png" />
                        </span>
                        <span v-if="edit_mode">
                          <el-checkbox v-model="checked" style="margin-right:0px"></el-checkbox>
                          <el-button type="text" size="mini" v-on:click="edit()" icon="el-icon-edit" style="color:gray;"></el-button>
                          <el-button type="text" size="mini" v-on:click="initiate_delete()" icon="el-icon-delete" style="margin:0px;color:gray;"></el-button>
                          <span style="color:gray">(Position: {{definition.order}})</span>
                        </span>
                    </div>
                    <span class="panel-body" style="padding: 0px!important">
                        <div style="padding: 8px 10px;">
                            <p v-if="definition.text && !overlay">{{definition.text}}</p>
                            <div v-if="definition.details_type === 'App\\ReportCompSingle'">
                                <ReportCompSingle
                                        :chart_config="definition.details.chart_config"
                                        :extent_id="definition.details.extent_id"
                                        :chart_height="definition.details.chart_config.chart_type==='horizontalbar' ? chart_height * 2 : chart_height"
                                        :chart_width="chart_width"
                                        :additional_filters="additional_filters"
                                        :snapshotId="snapshotId"
                                />
                            </div>
                            <div v-else-if="definition.details_type === 'App\\ReportCompVisualFilter'">
                                <ReportCompVisualFilter
                                    :chart_config="definition.details.chart_config"
                                    :extent_id="definition.details.extent_id"
                                    :chart_height="definition.details.chart_config.chart_type==='icicle' ? chart_height / 2 : chart_height"
                                    :chart_width="chart_width"
                                    @addedFilters="addedFilters($event)"
                                />
                            </div>
                            <div v-else>
                                <ReportCompSmallMult
                                        :definition="definition"
                                        :container_height="chart_height"
                                        :container_width="chart_width"
                                        :additional_filters="additional_filters"
                                />

                            </div>
                        </div>
                    </span>
                </div>
                <div class="modal-test" :style="overlay_style" v-if="overlay">
                    <h2 style="font-weight:bold;color:white;">{{definition.title}}</h2>
                    <p style="font-size:18px;color:white">{{definition.text}}</p>
                </div>
            </div>
            <div v-else-if="definition.details.annotation_id || definition.details.image_id">
                <div class="panel panel-default" :id="definition.css_id" :style="panel_style">
                    <div class="panel-heading" >
                        {{definition.title}}
                        <span style="float:left"  @click="showComments(definition)">
                          <img v-if="definition.comments && definition.comments.length" width="16px" src="/images/icons/have-noun-comment-1366158.png" />
                          <img v-else width="16px" src="/images/icons/none-noun-comment-1366158.png" />
                        </span>
                        <span v-if="edit_mode">
                          <el-checkbox v-model="checked" style="margin-right:0px"></el-checkbox>
                          <el-button type="text" size="mini" v-on:click="edit()" icon="el-icon-edit" style="color:gray;"></el-button>
                          <el-button type="text" size="mini" v-on:click="initiate_delete()" icon="el-icon-delete" style="color:gray;margin:0px;"></el-button>
                          <span style="color:gray">(Position: {{definition.order}})</span>
                        </span>
                    </div>
                    <span class="panel-body" style="padding: 0px!important">
                        <div style="padding: 8px 10px;">
                            <p v-if="definition.text">{{definition.text}}</p>
                            <div v-if="definition.details.annotation_id">
                                <ReportCompAnnotation :definition="definition" />
                            </div>
                            <div v-else>
                                <ReportCompImage :definition="definition" />
                            </div>
                        </div>
                    </span>
                </div>
            </div>
            <div v-else>
                <div :class="(!definition.details.heading_level || definition.details.heading_level===1) ? 'section' : 'subsection'">
                  <span @click="showComments(definition)">
                          <img v-if="definition.comments && definition.comments.length" style="vertical-align:middle" width="16px" src="/images/icons/have-noun-comment-1366158.png" />
                          <img v-else style="vertical-align:middle" width="16px" src="/images/icons/none-noun-comment-1366158.png" />
                  </span>
                  <span v-if="!definition.details.heading_level || definition.details.heading_level===1">
                      <h2 style="display:inline-block">{{definition.title}}</h2>
                  </span>
                  <span v-else-if="definition.details.heading_level===2">
                      <h3 style="display:inline-block">{{definition.title}}</h3>
                  </span>
                  <span v-else>
                      <h2 style="display:inline-block">{{definition.title}}</h2>
                  </span>

                    <span v-if="edit_mode">
                          <el-checkbox v-model="checked" style="margin-right:0px"></el-checkbox>
                          <el-button type="text" size="mini" v-on:click="edit()" icon="el-icon-edit" style="color:gray;"></el-button>
                          <el-button type="text" size="mini" v-on:click="initiate_delete()" icon="el-icon-delete" style="color:gray;margin:0px;"></el-button>
                          <span style="color:gray">(Position: {{definition.order}})</span>
                    </span>
                    <span v-else style="float:right;margin-top:10px;">
                             <el-button v-if="presentation_mode && definition.next_jump" icon="el-icon-caret-right" @click="jump"></el-button>
                    </span>

                  <ReportCompSectionBreak :definition="definition" :additional_filters="additional_filters" :snapshotId="snapshotId"
                  />
                </div>

            </div>

        </div>
    </div>
    
</template>

<script>
    import * as screenfull from "screenfull";
    import ReportCompSectionBreak from "./ReportCompSectionBreak";
    import ReportCompAnnotation from "./ReportCompAnnotation";
    import CommentThread from "../Comments/CommentThread.vue";

    export default {
        name: "ReportComp",
        components: {CommentThread, ReportCompAnnotation, ReportCompSectionBreak},
        props: ['definition','edit_mode','additional_filters','presentation_mode','margin_width','snapshotId'],
        watch: {
          checked: function () {
            this.$emit('checked', {
              checked: this.checked,
              id: this.definition.id
            });
          },
        },
        methods: {
            showComments(component_definition) {
              this.compForComments = component_definition
              this.show_comments = true
            },
            jump() {
              this.$emit('jump',this.definition.next_jump)
            },
            addedFilters(payload) {
              this.$emit('addedFilters', payload)
            },
            reload_definition() {
              axios.get("/reports/comps/" + this.definition.report_id + '/' + this.definition.id)
                  .then(response => {
                    this.definition = response.data
                  })
                  .catch(error => {
                    console.log("Could not reload after save")
                  })
            },
            initiate_delete() {
              this.show_delete = true
            },
            cancel_delete() {
              this.show_delete = false
            },
            really_delete() {
              axios.delete("/reports/comps/" + this.definition.report_id + '/' + this.definition.id)
                  .then(response => {
                    this.$emit('reload') // the entire REPORT needs to reload, which will reload this
                    // this.reload_definition()
                    this.show_delete = false
                    console.log('deleted')
                  })
                  .catch(error => {
                    console.log('oops could not delete')
                  })
            },
            save(values) {
              axios.post('/reports/comps/' + this.definition.report_id, {
                comp: values
              })
                  .then(response => {
                    this.reload_definition()
                    this.show_edit = false
                  })
                  .catch(error => {
                    console.log('oops could not save')
                  })
            },
            edit() {
              this.show_edit = true
            },
            cancel() {
              this.show_edit = false
            },
            full_screen(id) {
                const chart = document.getElementById(id)
                screenfull.request(chart)
                this.is_full_screen = true
                if (screenfull.enabled) {
                    screenfull.on('change', () => {
                        if (!screenfull.isFullscreen) this.is_full_screen = false
                    });
                }
            },
        },
        data() {
            return {
                show_comments: false,
                compForComments: null,
                is_full_screen: false,
                show_edit: false,
                show_delete: false,
                events: {
                  use: {
                    label: "Save" ,
                    event: "save"
                  },
                  cancel: {
                    label: "Cancel",
                    event: "cancel"
                  }
                },
                checked: false,
            }
        },
        computed: {
            definition_for_editor: function() {
              let def = {}
              def.title = this.definition.title
              def.text = this.definition.text
              if (this.definition.details_type==='App\\ReportCompSingle') {
                def.type = 'chart'
                def.chart_config = this.definition.details.chart_config_id
              } else if (this.definition.details_type==='App\\ReportCompAnnotation') {
                def.type = 'annotation'
                def.annotation = this.definition.details.annotation_id
              } else if (this.definition.details_type==='App\\ReportCompSectionBreak') {
                def.type = 'section_break'
                def.heading_level = this.definition.details.heading_level
              } else if (this.definition.details_type==='App\\ReportCompVisualFilter') {
                def.type = 'visual_filter'
                def.chart_config = this.definition.details.chart_config_id
              } else if (this.definition.details_type==='App\\ReportCompSmallMult') {
                def.type = 'small_multiples'
                def.chart_config = this.definition.details.chart_config_id
                def.dim1_field = this.definition.details.dim1_field
                def.dim1_values = this.definition.details.dim1_values
                def.dim1_type = this.definition.details.dim1_type
                def.interior_rows = this.definition.details.interior_rows
                def.interior_columns = this.definition.details.interior_columns
                // These are currently not exposed in the front end
                def.dim2_field = this.definition.details.dim2_field
                def.dim2_values = this.definition.details.dim2_values
              } else if (this.definition.details_type==='App\\ReportCompImage') {
                def.type = 'image'
                def.image = this.definition.details.image_id
              } else {
                console.log('****NO MATCH ON TYPE****')
              }
              def.columns = this.definition.columns
              def.order = this.definition.order
              def.details_id = this.definition.details_id
              def.id = this.definition.id
              def.report_id = this.definition.report_id
              def.slug= this.definition.slug
              return def
            },
            col_class: function () {
                return "col-md-" + this.definition.columns
            },
            chart_height: function() {
                let percentage = this.definition.columns / 12
                if (!this.is_full_screen) return 600 * percentage
                else {
                    return (screen.height * 0.8) - 30
                }
            },
            chart_width: function() {
                let percentage = this.definition.columns / 12
                // This width calculation isn't quite right, because the base width of
                // 1108 is only on a large enough monitor and full screen. Also, not sure
                // the other parts of the calculations are correct. But here's the logic:
                // Base width: 1108
                // Margin width (calculated from report since it knows all the columns): 30 * the gutters between columns
                // Padding in this column: 20 (10 pixels on either side)
                if (!this.is_full_screen) return (1108-this.margin_width-20) * percentage
                else {
                    return screen.width - 30
                }
            },
            overlay: function() {
                if (this.definition.style==2) return true;
                else return false;
            },
            overlay_style: function() {
                // obviously this calculation isn't that accurate
                let percentage = this.definition.columns / 12
                let margin_and_padding_pixels = this.definition.columns * 30
                let text_width_pixels = 1108 * percentage - margin_and_padding_pixels
                let style = "position:absolute;top:40px;left:40px;" + "width:" + text_width_pixels + "px;"
                return style
            },
            panel_style: function() {
                let z_index = 100;
                let opacity = 1;

                if (this.overlay) {
                    z_index = -1;
                    opacity = 0.5;
                }
                return "background-color:white; z-index:" + z_index + ";opacity:" + opacity
            },
            parent_style: function() {
              if (this.overlay) {
                  return "background-color:black;"
              }  else {
                  return "background-color:white;"
              }
            }
        }
    }
</script>
